<script setup lang="ts">
import { computed, ref } from 'vue'

console.log('CustomDatepicker.vue setup script')
const date = defineModel<Date | null>('date')
console.log('date:', date)
// Computed property to validate the date type
if (!date.value || !(date.value instanceof Date)) {
  throw new Error('Invalid date type')
}

const props = defineProps({
  header: {
    type: String,
    default: 'Date:'
  }
})

// Computed property to generate a valid id
const datePickerId = computed(() => {
  return props.header.replace(/\s+/g, '-').toLowerCase()
})

</script>

<template>
  <Card class="flex-row">
    <template #content>
      <label :for="datePickerId">{{ header }}: </label>
      <DatePicker v-model="date" view="date" :id="datePickerId" dateFormat="dd/mm/yy" @keydown.enter="$emit('update:date', date)" />
    </template>
  </Card>
</template>
